export default {
    "data": {
        "h5": {
            "imgObj": {
                "top": "https://s20.lgstatic.com/growth/activity/20220315/1647314792678.png",
                "btn1": "https://s20.lgstatic.com/growth/activity/20210907/1630995105866.png",
                "section1": "https://s21.lgstatic.com/growth/activity/20210907/1630995620269.png",
                "section2": "https://s21.lgstatic.com/growth/activity/20210907/1630995609312.png",
                "section3": "https://s20.lgstatic.com/growth/activity/20220315/1647314929137.png",
                "title": "https://s21.lgstatic.com/growth/activity/20210907/1630997966364.png",
                "ranktitle": "https://s20.lgstatic.com/growth/activity/20210907/1630998590879.png",
                "footer": "https://s21.lgstatic.com/growth/activity/20220426/1650954450173.png",
                "footer_icon": "https://s21.lgstatic.com/growth/activity/20210830/1630322109925.png",
            },
            "imgList": [
                "https://s20.lgstatic.com/growth/activity/20210907/1630982283074.png",
                "https://s21.lgstatic.com/growth/activity/20210907/1630982293385.png",
                "https://s20.lgstatic.com/growth/activity/20210907/1630982311965.png",
                "https://s20.lgstatic.com/growth/activity/20210907/1630982302602.png"
            ],
            "imgList1": [
                "https://s20.lgstatic.com/growth/activity/20210907/1630996647334.png",
                "https://s20.lgstatic.com/growth/activity/20211126/1637915302986.jpg",
                "https://s21.lgstatic.com/growth/activity/20220315/1647314836843.png"
            ],
            "swiperList": [
                "https://s21.lgstatic.com/growth/activity/20210907/1630995873045.png",
                "https://s20.lgstatic.com/growth/activity/20210907/1630995880638.png",
                "https://s20.lgstatic.com/growth/activity/20210907/1630995888429.png"
            ],
            "swiperList1": [
                "https://s20.lgstatic.com/growth/activity/20220620/1655710994843.png",
                "https://s20.lgstatic.com/growth/activity/20220620/1655711006776.png",
                "https://s20.lgstatic.com/growth/activity/20220620/1655711019882.png",
                "https://s20.lgstatic.com/growth/activity/20220620/1655711030871.png",
            ],
            "swiperList2": [
                "https://s21.lgstatic.com/growth/activity/20220620/1655711545102.png",
                "https://s20.lgstatic.com/growth/activity/20220620/1655711564537.png",
                "https://s21.lgstatic.com/growth/activity/20220620/1655711588836.png",
                "https://s20.lgstatic.com/growth/activity/20220620/1655711612517.png",
                "https://s21.lgstatic.com/growth/activity/20220620/1655711634297.png",
            ],
        },
        "pc": {
            "imgObj": {
                "top": "https://s21.lgstatic.com/growth/activity/20220623/1655953372930.png",
                "btn1": "https://s21.lgstatic.com/growth/activity/20210908/1631069021121.png",
                "btn2": "https://s21.lgstatic.com/growth/activity/20210908/1631081392305.png",
                "rank_title": "https://s21.lgstatic.com/growth/activity/20210908/1631085603287.png",
                "footer": "https://s20.lgstatic.com/growth/activity/20220623/1655969220617.png",
                "section1": "https://s21.lgstatic.com/growth/activity/20210908/1631069499937.png",
                "section2": "https://s20.lgstatic.com/growth/activity/20210908/1631069508151.png",
                "section3": "https://s21.lgstatic.com/growth/activity/20221118/1668750341558.jpg",
                "section4": "https://s20.lgstatic.com/growth/activity/20220624/1656040498548.png",
                "section5": "https://s20.lgstatic.com/growth/activity/20220623/1655969694834.png",
                "section6": "https://s20.lgstatic.com/growth/activity/20220623/1655969711737.png",
                "section7": "https://s21.lgstatic.com/growth/activity/20221118/1668750400273.jpg",
            },
            "imgList": [
                "https://s20.lgstatic.com/growth/activity/20220623/1655953405243.png",
                "https://s21.lgstatic.com/growth/activity/20220623/1655953444999.png",
                "https://s21.lgstatic.com/growth/activity/20220623/1655954011804.png",
                // "https://s21.lgstatic.com/growth/activity/20210908/1631068387349.png",
            ],
            "swiperList": [
                "https://s21.lgstatic.com/growth/activity/20210908/1631066593764.png",
                "https://s20.lgstatic.com/growth/activity/20220623/1655969852961.png",
                "https://s21.lgstatic.com/growth/activity/20220623/1655969877567.png"
            ],
            "swiperList1": [
                "https://s20.lgstatic.com/growth/activity/20220620/1655710994843.png",
                "https://s20.lgstatic.com/growth/activity/20220620/1655711006776.png",
                "https://s20.lgstatic.com/growth/activity/20220620/1655711019882.png",
                "https://s20.lgstatic.com/growth/activity/20220620/1655711030871.png",
            ],
            "swiperList2": [
                "https://s21.lgstatic.com/growth/activity/20220620/1655711545102.png",
                "https://s20.lgstatic.com/growth/activity/20220620/1655711564537.png",
                "https://s21.lgstatic.com/growth/activity/20220620/1655711588836.png",
                "https://s20.lgstatic.com/growth/activity/20220620/1655711612517.png",
                "https://s21.lgstatic.com/growth/activity/20220620/1655711634297.png",
            ],

        },
        "tabList1": [
            { "stage": "课程体系" },
            { "stage": "实战项目" },
            { "stage": "就业服务" },
            // { "stage": "私教模式" },
            // { "stage": "用户评价" },
        ],
        "tabList": [
            { "stage": "职业发展" },
            { "stage": "私教模式" },
            { "stage": "课程体系" },
            { "stage": "实战项目" },
            { "stage": "内推服务" },
        ],
        "stageList": [
            {
                "stage": "第一阶段",
                "title": "数据分析师思维逻辑",
                "phaseTargetList": [
                    "数据分析师如何帮助其他部门达成目标与协同工作",
                    "数据分析师新人如何梳理企业业务线",
                    "解读数据与大厂常见核心指标"
                ],
                "skillsList": [
                    "辅助线下连锁水果店销售额目标达成",
                    "在线教育机构运营策略监控分析"
                ],
                "details": [
                    {
                        "t": "经营业务分析项目一： 辅助线下连锁水果店销售额目标达成",
                        "desc": [
                            "企业利润结构组成",
                            "毛利额数据异常问题拆解",
                            "提升毛利额方案指标拆解",
                            "利用分组分析找到亏损店铺进行营销优化",
                            "运用对比分析、矩阵关联、趋势分析解决水果配货问题",
                            "利用同比，环比分析远近期经营数据走势",
                        ]
                    }, {
                        "t": "运营业务分析项目二： 在线教育机构运营策略监控分析",
                        "desc": [
                            "互联网企业核心业务模式介绍",
                            "提升毛利额方案业务拆解",
                            "运用逻辑树拆解定位毛利额下降原因",
                            "利用综合分析法挖掘优质渠道",
                            "运用 RFM 模型对学员做精细化运营",
                            "运用漏斗分析找出产品转化问题 ",
                        ]
                    },
                ]
            }, {
                "stage": "第二阶段",
                "title": "拒绝工具人、表哥表姐、SQLBoy标签",
                "phaseTargetList": [
                    "掌握数据分析师必备的 MySQL 分析能力",
                    "解读数据分析师的 MySQL 使用场景",
                    "学习如何操作企业级数据表格",
                    "学习用 SQL 语言描述企业数据业务"
                ],
                "skillsList": [
                    "汽车新零售案例分析",
                    "基于电商用户、商品、平台价值分析",
                    "招聘网站岗位分析"
                ],
                "details": [
                    {
                        "t": "MySQL 分析项目一：汽车新零售案例分析",
                        "desc": [
                            "客户线索成交需求分析",
                            "销售渠道转化率分析",
                            "根据城市线索数拓展线下门店与选址",
                            "优质投放渠道筛选提升 ROI"
                        ]
                    }, {
                        "t": "MySQL 分析项目二：基于电商用户、商品、平台价值分析",
                        "desc": [
                            "用户信息表设计与搭建",
                            "订单数据导入",
                            "数据表及字段的增删改操作",
                            "业务数据关联 — 外连接、内连接、自连接与自然连接",
                            "数据分析常用的 MySQL 函数",
                            "市场需求量与企业类型的分布",
                            "岗位工作年限与薪资双变量分析",
                            "统计岗位的核心技能 人货场指标体系",
                            "用户基础指标 — UV、PV与浏览深度",
                            "活跃用户留存指标实现分析",
                            "如何利用 RFM 模型筛选高价值用户",
                            "如何通过窗口函数生成用户行为路径，并分析优化产品，提升转化"
                        ]
                    }, {
                        "t": "MySQL 分析项目三：招聘网站岗位分析",
                        "desc": [
                            "依据于业务通过 SQL 语句进行数据清洗",
                            "不同企业都喜欢招聘哪些岗位",
                            "MySQL 分析企业平均薪资波动",
                            "各岗位必备核心技能"
                        ]
                    },
                ]
            }, {
                "stage": "第三阶段",
                "title": "掌握 BI 商业智能，数据可视化高人一等",
                "phaseTargetList": [
                    "使用 BI 工具制作自动化报表监控企业关键指标",
                    "如何从0 到 1 搭建企业级可视化大屏",
                    "学习主流 BI 商业智能工具（Tableau，QuickBI，神策）",
                    "掌握 BI 分析师和数据产品经理的核心能力"
                ],
                "skillsList": [
                    "新零售行业销售数据自动化监控报表搭建",
                    "拉勾教育自动化经营分析可视化大屏",
                    "如何通过阿里 AIPL 模型实现用户全生命周期管理"

                ],
                "details": [
                    {
                        "t": "Tableau 可视化项目一：新零售行业销售数据自动化监控报表搭建",
                        "desc": [
                            "零售行业销售环节最关心哪些核心数据指标",
                            "通过“人货场”模型梳理零售行业业务模式",
                            "如何确定零售行业北极星指标",
                            "同环比分析法监控业绩数据波动",
                            "KPI 分析法监控门店目标达成率",
                            "对比分析法动态展示产品畅销榜",
                            "占比分析法展示客户性别、年龄等用户画像信息",
                            "地理分布分析展示不同用户地理分布情况"
                        ]
                    }, {
                        "t": "Tableau 可视化项目二：拉勾教育自动化经营分析可视化大屏",
                        "desc": [
                            "深度剖析在线教育商业模式和盈利模式",
                            "手把手教你梳理在线教育全业务流程",
                            "带你揭秘老板最关心的几项核心指标",
                            "如何通过 5W2H 分析法拆解老板需求",
                            "如何通过 Tableau 连接数据库实现数据实时更新",
                            "大屏可视化布局的秘密",
                            "如何科学的进行图表设计和颜色搭配",
                            "如何通过 Tableau 发布成果，在线共享协作",
                            "象限分析法筛选优质课程",
                            "漏斗分析法监控各业务环节转化率",
                            "对比分析法监控渠道引流质量",
                            "地理分布分析展示用户地理分布情况"
                        ]
                    }, {
                        "t": "神策可视化项目三：如何通过阿里 AIPL 模型实现用户全生命周期管理",
                        "desc": [
                            "互联网下半场，如何通过数据驱动用户精细化运营",
                            "如何通过“事件（Event）模型”合理描述用户行为",
                            "如何通过埋点设计科学采集用户行为数据",
                            "获客阶段，如何以更低成本获取更多的用户",
                            "留存阶段，如何持续激发用户兴趣，防止流失",
                            "购买阶段，如何让更多人付费，如何让一个人付更多钱",
                            "裂变阶段，如何让用户认可品牌价值，为品牌发声"
                        ]
                    },
                ]
            }, {
                "stage": "第四阶段",
                "title": "大数据存储与查询利器 Hive",
                "phaseTargetList": [
                    "学习海量数据业务框架、掌握复杂业务环境下的业务数据整理、数据抽取能力",
                    "掌握在 TB 级数据仓库中高速计算数据能力",
                    "掌握高阶 HQL 语言技巧复现业务能力",
                    "对复杂业务和海量数据做合理数据分层提高数据应用效率"
                ],
                "skillsList": [
                    "爱奇艺提高广告曝光量",
                    "社区电商【小红书】用户增长监控"
                ],
                "details": [
                    {
                        "t": "海量数据项目一：爱奇艺提高广告曝光量",
                        "desc": [
                            "需求方向业务数仓分层 — 为后续扩展及维护带来便利",
                            "以数据库进行层级结构划分 — 使业务规范更清晰",
                            "用户信息利用复合类型存储 — 使数据结构更清晰",
                            "行为信息利用表分区、分桶存储 — 提高检索及 join 速度",
                            "深度解析协同过滤推荐算法原理及各种相似度计算方法",
                            "利用协同过滤为用户精准推荐电影 — 高播放量"
                        ]
                    }, {
                        "t": "海量数据项目二：社区电商【小红书】用户增长监控",
                        "desc": [
                            "小红书快速发展的原因 — 完善的用户增长体系拆解",
                            "定义用户各状态判断规则",
                            "使用 HQL 根据用户行为及判断规则划分用户状态",
                            "Tableau 连接 Hive，监控​用户各状态变化情况"
                        ]
                    },
                ]
            },{
                "stage": "第五阶段",
                "title": "数据分析与自动化办公必备利器：Python",
                "phaseTargetList": [
                    "面对灵活且复杂的数分需求，利用 Python 进行数据处理与分析",
                    "如何复杂而灵活的定制可视化实现方案",
                    "解放双手，Python 自动化办公才是未来发展趋势",
                    "利用 Python 爬虫技术，获取更多行业信息辅助分析"
                ],
                "skillsList": [
                    "天猫双 11 美妆行业整体销售数据分析",
                    "互联网岗位招聘数据采集与分析",
                    "Olist 巴西电商销售数据分析"
                ],
                "details": [
                    {
                        "t": "Python 数据分析全流程 - 项目一：天猫双 11 美妆行业整体销售数据分析",
                        "desc": [
                            "数据预处理：缺失值、去重、2 次检索与特征规范化",
                            "建立商品标签与商品分类的映射关系，划分商品多级分类",
                            "利用等频分箱与等宽分箱为细分商品类别划分合适的价格区间",
                            "产品单价与销售额的双变量分析",
                            "各个品牌的整体与细分市场占有率与销售额",
                            "虚假数据诊断、如何检测用户刷单的异常数据",
                            "预测 — 为促销活动选择最佳的推广时间"
                        ]
                    }, {
                        "t": "Python 自动化办公与爬虫 - 项目二：互联网岗位招聘数据采集与分析",
                        "desc": [
                            "Selenium 自动化采集全行业分类信息",
                            "分类数据清洗处理并生成 Excel 文件",
                            "SQLAlchemy、Pickle 模块应用与 Pandas 操作 MySQL",
                            "页面 URL 规则分析与 URL 编码解码",
                            "基于 Scrapy 开发分布式数据采集引擎",
                            "市场需求分析：各行业人才需求与竞争度分析",
                            "就业企业分析：出口企业类型分布",
                            "岗位晋升分析：工作年限与岗位薪资的双变量分析",
                            "核心技能分析：筛选岗位高频技能点，并绘制技能图谱"
                        ]
                    }, {
                        "t": "Python 经营分析与可视化 - 项目三：Olist 巴西电商销售数据分析",
                        "desc": [
                            "理解数据：梳理数据库结构，建立数据宽表",
                            "跟踪数据：产品销售额与销量变化趋势",
                            "热门商品：获得各个细分领域TOP10 商品",
                            "区域分析：各个城市与用户地域分布图",
                            "支付行为：买家的支付行为占比、分期付款风险复盘",
                            "评论分析：基于 NLP 技术进行评论内容分析",
                            "分析报告：基于各项分析结论，撰写数分报告"
                        ]
                    },
                ]
            },{
                "stage": "第六阶段",
                "title": "高级数据分析师必备：统计学",
                "phaseTargetList": [
                    "如何通过描述性统计从数据中发现问题",
                    "如何通过总体推断方法提升你的数据大局观",
                    "一个优秀的数据分析师必须学会使用统计模型预测未来"
                ],
                "skillsList": [
                    "某通信运营商 APP 用户数预测分析"
                ],
                "details": [
                    {
                        "t": "统计学项目一：某通信运营商 APP 用户数预测分析",
                        "desc": [
                            "如何通过数据分析正确拆解目标需求",
                            "如何科学选择合适的方法构建分析模型",
                            "如何科学选择合适的评价指标对模型进行评估",
                            "建立多元回归方程对业务进行拟合",
                            "对模型的拟合结果进行效果评估",
                            "通过高拟合模型对业务进行预测"
                        ]
                    },
                ]
            },{
                "stage": "第七阶段",
                "title": "高阶数据分析核心能力 - 数据指标体系和 ABTest",
                "phaseTargetList": [
                    "企业渠道增长运营、电商平台流量平衡项目需求实现",
                    "学习企业数据驱动的核心思想与核心技能 — 指标体系搭建",
                    "学习企业数据决策的核心技能 — ABTest"
                ],
                "skillsList": [
                    "拉勾教育业务指标体系搭建及监控",
                    "淘宝平台中小店铺流量扶持之 ABTest"
                ],
                "details": [
                    {
                        "t": "全局指标体系项目一：拉勾教育业务指标体系搭建及监控",
                        "desc": [
                            "掌握渠道运营、社群运营、销售等团队核心指标",
                            "以数据分析总监视野从 0 到 1 搭建企业指标体系",
                            "理解企业数据驱动本质，掌握企业数据驱动核心技能",
                            "以拉勾教育为业务基石深入探究企业指标体系搭建的每个细节",
                            "10 年大厂经验导老师手把手带你实现设定北极星指标、搭建企业指标体系模型、从用户旅程中梳理基础业务表、从用户路径上设计事件、以指标体系模型为基础实现业务表、指标体系可视化调度报表系统搭建等等关键流程",
                            "在指标体系的基础上梳理日报监控核心指标",
                        ]
                    }, {
                        "t": "大厂 ABTest 实战项目二：淘宝平台中小店铺流量扶持之 ABTest",
                        "desc": [
                            "市面上少有的 ABTest超完整教程",
                            "利用 ABTest 促进淘宝电商平台中小企业成单量，学习平台型企业 2B 端用户运营核心策略",
                            "全面认识 ABTest，测试立项、实验设计、策略开发、用户分流、灰度发布、埋点数据收集与分析、假设检验、发版推全",
                            "全程超简单逻辑推导假设检验过程，即使文科生也能学会",
                            "Python 代码实现 ABTest 关键计算环节，让同学从细节学会 ABTest",
                            "多场景教学 ABTest 必会变形，学以致用"
                        ]
                    },
                ]
            },{
                "stage": "第八阶段",
                "title": "深入数据分析与数据挖掘",
                "phaseTargetList": [
                    "解析数据挖掘与数据分析的关系",
                    "数据挖掘常用算法原理及优缺点",
                    "各类模型评估方法及优缺点"
                ],
                "skillsList": [
                    "金融保险用户分类",
                    "电商文本挖掘",
                    "通过用户的后续价值提升大促 ROI"
                ],
                "details": [
                    {
                        "t": "挖掘项目一：金融保险用户分类",
                        "desc": [
                            "EDA — 项目数据探索了解数据集、验证数据",
                            "​清洗数据 — 缺失值处理",
                            "​特征工程 — 离散数据编码、特征选择",
                            "​选择模型建模 — 用显著特征建立用户分类模型",
                            "​决策树模型调参使得分类模型准确度更高"
                        ]
                    }, {
                        "t": "挖掘项目二：电商文本挖掘",
                        "desc": [
                            "商品整体市场需求量分析",
                            "商品各品牌市场销量占比分析",
                            "通过 Matplot 绘图对比分析商品流量下滑原因",
                            "通过 jieba 进行商品评论内容舆情分析",
                            "利用 TF-IDF 抽取评论关键词并词云图绘制找到用户关注点及态度"
                        ]
                    }, {
                        "t": "挖掘项目三：通过用户的后续价值提升大促 ROI",
                        "desc": [
                            "梳理挖掘项目完整流程",
                            "了解电商 B2C 商业模式",
                            "体验 B2C 商家数据分析师日常工作",
                            "大促后对新用户复购概率预测",
                            "对备选模型会 KNN、LR、决策树、RF、Adaboost、XGBoost 等进行筛选",
                            "利用 GridSearch 对优质模型进行调参"
                        ]
                    },
                ]
            },{
                "stage": "第九阶段",
                "title": "企业商业分析报告撰写",
                "phaseTargetList": [
                    "拒绝无用的探索性报告，掌握有建设性意见的商业分析报告书写方法"
                ],
                "skillsList": [
                    "资深数据分析师带你拆解携程商业分析报告"
                ],
                "details": [
                    {
                        "t": "震惊业界的分析报告流程与制作项目：资深数据分析师带你拆解携程商业分析报告",
                        "desc": [
                            "资深数据分析师告诉你如何写好 一 份数据分析报告",
                            "​从源头解决写不出来报告、只有展示没有分析、重复分析、论点不集中、论点空想等多种问题",
                            "​从问题开始做出直指业务痛点的大纲",
                            "​学会抛弃“从数据中写报告”的错误报告制作思路",
                            "​利用在线旅游企业海外酒店房态业务制作报告"
                        ]
                    },
                ]
            },{
                "stage": "第十阶段",
                "title": "核心就业服务：就业指导 + 简历指导",
                "phaseTargetList": [
                    "熟练应对大厂数据分析岗位的笔试题",
                    "具备大厂优秀简历制作能力",
                    "具备大厂模拟面试通关能力",
                    "具备大厂青睐的项目撰写和项目答辩能力"
                ],
                "skillsList": [
                    "高分简历模板分析 打造一份高分简历的方法"
                ],
                "details": [
                    {
                        "t": "高分简历模板分析 打造一份高分简历的方法 ",
                        "desc": [
                            "学会表达：如何把硬实力表达出来",
                            "扬长避短：如何表现出自己的闪光点",
                            "洞悉套路：面试考察点与答题套路指导",
                            "模拟训练：大厂面试官1v1模拟面试",
                            "扬长避短：如何表现出自己的闪光点",
                        ]
                    }
                ]
            }
        ],
        "rankList": [
            {
                "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606199628854.jpg",
                "companyName": "京东",
                "name": "张同学",
                "workYears": 5,
                "education": "本科",
                "term": "Java高薪5期",
                "salary": 378000,
                "change": "215%"
            },
            {
                "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606199812134.jpg",
                "companyName": "阿里巴巴",
                "name": "赵同学",
                "workYears": 3,
                "education": "本科",
                "term": "Java高薪3期",
                "salary": 247000,
                "change": "106%"
            },
            {
                "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606199856501.jpg",
                "companyName": "36Kr",
                "name": "沈同学",
                "workYears": 3,
                "education": "本科",
                "term": "Java高薪3期",
                "salary": 192000,
                "change": "100%"
            },
            {
                "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606199885502.jpg",
                "companyName": "去哪儿",
                "name": "董同学",
                "workYears": 3,
                "education": "本科",
                "term": "Java高薪3期",
                "salary": 352000,
                "change": "96%"
            },
            {
                "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606199921463.jpg",
                "companyName": "美团",
                "name": "姜同学",
                "workYears": 5,
                "education": "本科",
                "term": "Java高薪2期",
                "salary": 280000,
                "change": "94%"
            },
            {
                "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606199943547.jpg",
                "companyName": "知网",
                "name": "邵同学",
                "workYears": 5,
                "education": "本科",
                "term": "Java高薪4期",
                "salary": 336000,
                "change": "94%"
            },
            {
                "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606199982790.jpg",
                "companyName": "好未来",
                "name": "韩同学",
                "workYears": 3,
                "education": "大专",
                "term": "Java高薪1期",
                "salary": 180000,
                "change": "88%"
            },
            {
                "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606200033139.jpg",
                "companyName": "华为",
                "name": "董同学",
                "workYears": 2,
                "education": "大专",
                "term": "Java高薪7期",
                "salary": 312000,
                "change": "86%"
            },
            {
                "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606200077489.jpg",
                "companyName": "360",
                "name": "陈同学",
                "workYears": 3,
                "education": "本科",
                "term": "Java高薪2期",
                "salary": 256000,
                "change": "78%"
            },
            {
                "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606200107965.jpg",
                "companyName": "用友",
                "name": "崔同学",
                "workYears": 3,
                "education": "本科",
                "term": "Java高薪3期",
                "salary": 252000,
                "change": "75%"
            },
            {
                "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606200159203.jpg",
                "companyName": "映客直播",
                "name": "楚同学",
                "workYears": 4,
                "education": "大专",
                "term": "Java高薪1期",
                "salary": 168000,
                "change": "75%"
            },
            {
                "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606200198284.jpg",
                "companyName": "得到",
                "name": "刘同学",
                "workYears": 1,
                "education": "硕士",
                "term": "Java高薪2期",
                "salary": 285000,
                "change": "70%"
            },
            {
                "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606200240740.jpg",
                "companyName": "虎牙直播",
                "name": "朱同学",
                "workYears": 5,
                "education": "大专",
                "term": "Java高薪2期",
                "salary": 286000,
                "change": "70%"
            },
            {
                "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606200284116.jpg",
                "companyName": "高德地图",
                "name": "李同学",
                "workYears": 2,
                "education": "大专",
                "term": "Java高薪4期",
                "salary": 168000,
                "change": "69%"
            },
            {
                "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606200323623.jpg",
                "companyName": "优酷",
                "name": "汪同学",
                "workYears": 1,
                "education": "本科",
                "term": "Java高薪2期",
                "salary": 168000,
                "change": "67%"
            },
            {
                "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606200370032.jpg",
                "companyName": "网易",
                "name": "韩同学",
                "workYears": 5,
                "education": "大专",
                "term": "Java高薪1期",
                "salary": 260000,
                "change": "67%"
            },
            {
                "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606200856686.jpg",
                "companyName": "北京久其股份软件有限公司",
                "name": "王同学",
                "workYears": 3,
                "education": "大专",
                "term": "Java高薪3期",
                "salary": 280000,
                "change": "67%"
            },
            {
                "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606200444696.jpg",
                "companyName": "蚂蚁金服",
                "name": "白同学",
                "workYears": 3,
                "education": "硕士",
                "term": "Java高薪4期",
                "salary": 319600,
                "change": "66%"
            },
            {
                "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606200539095.jpg",
                "companyName": "盒马生鲜",
                "name": "唐同学",
                "workYears": 2,
                "education": "本科",
                "term": "Java高薪4期",
                "salary": 156000,
                "change": "63%"
            },
            {
                "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606199856501.jpg",
                "companyName": "36Kr",
                "name": "郭同学",
                "workYears": 7,
                "education": "本科",
                "term": "Java高薪4期",
                "salary": 192000,
                "change": "60%"
            },
            {
                "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606200821777.jpg",
                "companyName": "知识星球",
                "name": "李同学",
                "workYears": 3,
                "education": "本科",
                "term": "Java高薪1期",
                "salary": 96000,
                "change": "60%"
            },
            {
                "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606200935260.jpg",
                "companyName": "江苏银行",
                "name": "李同学",
                "workYears": 6,
                "education": "本科",
                "term": "Java高薪4期",
                "salary": 250000,
                "change": "60%"
            },
            {
                "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606200987728.jpg",
                "companyName": "叮当快药",
                "name": "张同学",
                "workYears": 3,
                "education": "本科",
                "term": "Java高薪2期",
                "salary": 192000,
                "change": "60%"
            },
            {
                "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606201045655.jpg",
                "companyName": "怪兽充电",
                "name": "周同学",
                "workYears": 5,
                "education": "硕士",
                "term": "Java高薪2期",
                "salary": 325000,
                "change": "59%"
            },
            {
                "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606201103899.jpg",
                "companyName": "作业帮",
                "name": "孙同学",
                "workYears": 8,
                "education": "大专",
                "term": "Java高薪1期",
                "salary": 420000,
                "change": "59%"
            },
            {
                "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606200159203.jpg",
                "companyName": "映客",
                "name": "张同学",
                "workYears": 3,
                "education": "本科",
                "term": "Java高薪2期",
                "salary": 180000,
                "change": "58%"
            },
            {
                "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606201187882.jpg",
                "companyName": "知乎",
                "name": "刘同学",
                "workYears": 4,
                "education": "本科",
                "term": "Java高薪3期",
                "salary": 190000,
                "change": "58%"
            },
            {
                "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606201230432.jpg",
                "companyName": "闲鱼",
                "name": "曲同学",
                "workYears": 5,
                "education": "大专",
                "term": "Java高薪3期",
                "salary": 288000,
                "change": "50%"
            },
            {
                "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606200033139.jpg",
                "companyName": "华为",
                "name": "朱同学",
                "workYears": 3,
                "education": "本科",
                "term": "Java高薪5期",
                "salary": 288000,
                "change": "50%"
            },
            {
                "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606201326425.jpg",
                "companyName": "广发",
                "name": "欧同学",
                "workYears": 6,
                "education": "本科",
                "term": "Java高薪1期",
                "salary": 216000,
                "change": "50%"
            }
        ]

    }
}
